function buildCallTitle(outlineCall, recordingTitle) {
  return outlineCall?.title?.trim() || recordingTitle.trim();
}
export {
  buildCallTitle
};
//# sourceMappingURL=teammateAccountCallOutline.js.map
